import { unescape as s } from "./help-center-articles-search46.js";
let e = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: s
};
const r = (t = {}) => {
  e = {
    ...e,
    ...t
  };
};
export {
  r as setDefaults
};
//# sourceMappingURL=help-center-articles-search45.js.map
